<div class="d-flex align-items-center">
    @if (isAuthed$ | async) {
        <div class="d-flex flex-column align-items-end">
            <i class="fas fa-calendar-xmark"></i>
        </div>
        <div class="ms-2">Calendar integration is not enabled.</div>
    } @else {
        <div class="d-flex flex-column align-items-end integration-icon">
            <i class="fas fa-calendar-xmark integration-disabled-icon"></i>
        </div>
        <button role="button"
                type="button"
                class="btn btn-primary ms-4"
                [disabled]="disabled"
                [adaptBlockingClick]="login">Disable calendar integration</button>
    }
</div>
